import { render } from "./buttonOpportunityFarms.vue?vue&type=template&id=4a6b37ad"
import script from "./buttonOpportunityFarms.vue?vue&type=script&lang=js"
export * from "./buttonOpportunityFarms.vue?vue&type=script&lang=js"

import "./buttonOpportunityFarms.vue?vue&type=style&index=0&id=4a6b37ad&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__